import dayjs from 'dayjs';
export const toKebabCase = (string) => {
    return string
        .replace(/([a-z])([A-Z])/g, '$1-$2')
        .replace(/[\s_]+/g, '-')
        .toLowerCase();
};
export const camelCaseToTitleString = (text) => {
    const spacedText = text.replace(/([A-Z])/g, ' $1');
    return spacedText.charAt(0).toUpperCase() + spacedText.slice(1);
};
/**
 *
 * @param url - url of image. Only a cloudinary url will be resized
 * @param width - optional: defaults to 800
 * @param height - optional
 * @returns - resized cloudinary url or original url
 */
export const resizeImage = (url = '', width = 800, height) => {
    if (Array.isArray(url)) {
        return resizeImage(url[0], width, height);
    }
    if (!url) {
        return '';
    }
    let hostname = '';
    try {
        hostname = new URL(url).hostname;
    }
    catch {
        return url;
    }
    const isCloudinary = hostname === 'res.cloudinary.com';
    const isTroveCdn = hostname.includes('media-') && (hostname.endsWith('.trovesite.com') || hostname.endsWith('.yerdlesite.com'));
    if ((isCloudinary || isTroveCdn) && url.includes('/upload/')) {
        const splitUrl = url.split('/upload/');
        const remainder = splitUrl.slice(1).join('/upload/');
        const remainderSegments = remainder.split('/');
        // Any segment already containing a `w_` width param is a previously-applied transformation
        // and must be dropped here, or it would be kept and stacked alongside the new one below.
        if (remainderSegments[0]?.includes('w_')) {
            remainderSegments.shift();
        }
        const imageQueries = ['c_fit', 'f_auto', 'q_auto:eco', `w_${width}`];
        if (height) {
            imageQueries.push(`h_${height}`);
        }
        const newUrl = `${splitUrl[0]}/upload/${imageQueries.join(',')}/${remainderSegments.join('/')}`;
        return newUrl;
    }
    return url;
};
/**
 * Converts a hex color string to an rgb string
 * @param hex - hex color string with # prefix
 * @returns - rgb string (e.g. '255, 255, 255')
 */
export const hexToRgb = (hex) => {
    const stringified = hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b)
        .substring(1)
        .match(/.{2}/g);
    if (stringified) {
        return stringified.map(x => parseInt(x, 16))
            .join(', ');
    }
};
export const toSentenceCase = (str) => {
    return str.toLowerCase().charAt(0).toUpperCase() + str.toLowerCase().slice(1);
};
/** This function extracts the company name and code from a string in the format "Company Name (CODE)" */
export const extractCompanyNameAndCode = (str = '') => {
    const regex = /^(.+?) \((.+?)\)$/;
    const match = str.match(regex);
    if (match) {
        const companyName = match[1];
        const code = match[2].toLowerCase();
        return { companyName, code };
    }
    return null;
};
/**
 * Formats a given date into a string based on the specified format of the browser's locale/country.
 *
 * @param date - Can be a string, number, Date object, or Dayjs Object.
 *               If the date is invalid or not provided, an empty string is returned.
 * @param format - The format string to use for formatting the date. Defaults to 'L'.
 *                 The format should follow the Day.js formatting rules. Setting to 'iso' will format the date as ISO 8601
 *                 and account for user's timezone offset.
 *                 See: https://day.js.org/docs/en/display/format for the many options
 * @returns The formatted date string, or an empty string if the input date is invalid.
 */
export const formatLocalizedDate = (date, format = 'L') => {
    if (!date)
        return '';
    let newFormat;
    if (format === 'iso')
        newFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    if (dayjs.isDayjs(date))
        return date.format(newFormat || format);
    return dayjs(date).isValid() ? dayjs(date).format(newFormat || format) : '';
};
//# sourceMappingURL=utils.js.map